import { Component, OnInit } from '@angular/core';
import { StreamService } from 'src/app/services/stream.service';
import { vPlayer } from 'src/app/models/vPlayer';
import { Stream } from 'src/app/models/stream';
import { ActivatedRoute } from '@angular/router';
import { CourseService } from 'src/app/services/course.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AccountService } from 'src/app/services/account.service';
import { StreamProgrammeComponent } from 'src/app/components/modals/stream-programme/stream-programme.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Component({
  selector: 'app-stream',
  templateUrl: './stream.component.html',
  styleUrls: ['./stream.component.scss']
})
export class StreamComponent implements OnInit {
  public vPlayer: vPlayer;
  public stream: Stream;
  private stream_id:number;
  public loading:boolean = true;
  public metaLoading:boolean = true;
  public loggedIn:boolean = false;
  public userCanWatch:boolean = false;
  public imageUrl:string='';
  public showNotFound:boolean=false;
  public showUnavailable:boolean=false;
  public DefaultTimeZone:boolean = true;
  public TypePoints:string = 'CPD';


  constructor(
    private _streamService: StreamService,
    private _route: ActivatedRoute,
    private _courseService: CourseService,
    private _authenticationService: AuthenticationService,
    private _accountService: AccountService,
    public _dialog: MatDialog,
    private _notify: MatSnackBar,
    private _router: Router,
    private timezoneService: TimeZoneService
  ) {
    this.imageUrl=environment.apiEndpoint+'/storage/supporters/';
    this._authenticationService.loggedIn.subscribe(state=>{
      this.loggedIn = state;
    })
    this.vPlayer = new vPlayer;
    this._route.params.subscribe(res=>{
      this.stream_id=res.id;

      if(this.loggedIn){
        this._accountService.checkUserStreamAccess(this.stream_id).subscribe(data=>{
          // console.log(data);
          if(data.status=='success'){
            this.userCanWatch=true;
          }
        })
      }

      this._streamService.getStream(this.stream_id).subscribe((data:any) => {
        if (data.status && data.status=='Stream not found') {
          this.showNotFound=true;
        } else if(data.status && data.status=='Stream unavailable') {
          this.showUnavailable=true;
        } else {
          this.stream=data[0];
          this.streamCPD();
          this.vPlayer.options={
            id: data[0].vimeo_id,
          };
        }
        this.loading=false;
      });

    })
  }

  streamCPD(){
    this.stream.minutes=0;
    this.stream.active_courses.forEach((data, index) => {
      this.stream.minutes+=data.course.points;
      if(this.loggedIn) {
        this._courseService.getCourseMeta(data.course.id).subscribe(data => {

          this.stream.active_courses[index].meta=data;
          //console.log(this.stream.active_courses);
        });
      }
    });
    this.metaLoading=false;
  }

  ngOnInit() {
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();

    if(!this.DefaultTimeZone){
      this.TypePoints = 'CE';
    }

  }

  public notify(message:string, action:string) {
    this._notify.open(message, action, {
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  addToTP(){
    const dialogRef = this._dialog.open(StreamProgrammeComponent, {
      width: '450px',
      data: {stream:this.stream}
    });

    dialogRef.afterClosed().subscribe(res=>{
      if (res) {
        this.notify('Training Programme has been updated.','OK');
      }
    });
  }

  addToWL(){
    this.stream.active_courses.forEach((course, i) => {
      setTimeout( () => { 
        this._courseService.addToWatchlist(course.course_id).subscribe() 
      }, i * 1000);
    });
    this.notify('Stream added to Watchlist', 'OK');
  }

  redirectToPricing(){
    this._router.navigate(['/pricing']);
  }

}
